__turbopack_context__.v({
  "caption": "Video-module-scss-module__3ilIgW__caption",
  "captionContainer": "Video-module-scss-module__3ilIgW__captionContainer",
  "captionOnHover": "Video-module-scss-module__3ilIgW__captionOnHover",
  "explaining": "Video-module-scss-module__3ilIgW__explaining",
  "first": "Video-module-scss-module__3ilIgW__first",
  "grouped": "Video-module-scss-module__3ilIgW__grouped",
  "imageButton": "Video-module-scss-module__3ilIgW__imageButton",
  "licensedArticle": "Video-module-scss-module__3ilIgW__licensedArticle",
  "longform": "Video-module-scss-module__3ilIgW__longform",
  "mainVideo": "Video-module-scss-module__3ilIgW__mainVideo",
  "news": "Video-module-scss-module__3ilIgW__news",
  "noPadding": "Video-module-scss-module__3ilIgW__noPadding",
  "thumbnailContainer": "Video-module-scss-module__3ilIgW__thumbnailContainer",
  "thumbnailImage ": "Video-module-scss-module__3ilIgW__thumbnailImage ",
  "videoPlayer": "Video-module-scss-module__3ilIgW__videoPlayer",
});
